import React from 'react';

let Quote = require('../Managers/Quote');

const CheckboxInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        question:   React.PropTypes.string.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired,
        forcePushLocalStorageValue: React.PropTypes.bool,
    },

    getInitialState() {
        return {
            isChecked: false,
            activeValue: (this.props.loadCachedValue) ? Quote.getCurrentAnswer(this.props.fieldName) : null,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName) !== null) ? true : false,
        };
    },

    componentWillMount() {
        // Set the checked state if a positive answer has been cached previously
        ('yes' === Quote.getCurrentAnswer(this.props.fieldName) ?
            this.setState({ isChecked: true })
            :
            this.setState({ isChecked: false })
        );
    },

    /**
     * Handles click event of pseudo checkbox. If we're forcing values (as in
     * static questions, rather than data-driven), then we can force the
     * LocalStorage to be updated accordingly.
     */
    handleClick() {
        if (true === this.state.isChecked) {
            this.setState({ isChecked: false });
            document.getElementById(this.props.fieldName).checked = false;
            if (true === this.props.forcePushLocalStorageValue) {
                window.setLocalStorageAnswer(this.props.fieldName, 'no');
            }
        } else {
            this.setState({ isChecked: true });
            document.getElementById(this.props.fieldName).checked = true;
            if (true === this.props.forcePushLocalStorageValue) {
                window.setLocalStorageAnswer(this.props.fieldName, 'yes');
            }
        }
    },

    render() {
        let FaCheck = require('react-icons/lib/fa/check');
        let classSelected = this.state.isChecked === true ? 'clickable selected' : 'clickable';
        return (
            <div className="checkbox">
                <div className="pseudo-checkbox">
                    <div
                        className={classSelected}
                        aria-labelledby={this.props.fieldName + '-label'}
                        onClick={this.handleClick.bind(null, this)}
                    >
                        {this.state.isChecked ? (
                            <FaCheck
                                className="icon"
                            />
                        ) : null}
                    </div>
                    <label htmlFor={this.props.fieldName} id={this.props.fieldName + '-label'}>
                        <input
                            type="checkbox"
                            id={this.props.fieldName}
                            name={this.props.fieldName}
                        /> {this.props.question}
                    </label>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
});

export default CheckboxInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/CheckboxInput.js
 **/